import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { LiaBasketballBallSolid, LiaBookSolid, LiaSchoolSolid, LiaUserGraduateSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const WaitingBySegmentChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Custom tooltip component to remove shadow
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-gray-800 text-white px-3 py-2 rounded-lg border-none shadow-none">
          <p className="text-sm font-medium">{`Segmento: ${data.name}`}</p>
          <p className="text-sm">{`${data.value.toLocaleString()}`}</p>
        </div>
      );
    }
    return null;
  };
  const getSegmentLabel = (segmentKey) => {
    switch (segmentKey) {
      case 'preschool':
        return 'Infantil';
      case 'elementary-I':
        return 'Fundamental I';
      case 'elementary-II':
        return 'Fundamental II';
      case 'high-school':
        return 'Médio';
      default:
        return segmentKey;
    }
  }

  const getIconForSegment = (segmentKey) => {
    switch (segmentKey) {
      case 'preschool':
        return <LiaBasketballBallSolid className="w-4 h-4" />;
      case 'elementary-I':
        return <LiaBookSolid className="w-4 h-4" />;
      case 'elementary-II':
        return <LiaSchoolSolid className="w-4 h-4" />;
      case 'high-school':
        return <LiaUserGraduateSolid className="w-4 h-4" />;
      default:
        return <LiaBasketballBallSolid className="w-4 h-4" />;
    }
  }

  const getColorForSegment = (segmentKey) => {
    switch (segmentKey) {
      case 'preschool':
        return '#8B5CF6';
      case 'elementary-I':
        return '#3B82F6';
      case 'elementary-II':
        return '#10B981';
      case 'high-school':
        return '#F59E0B';
      default:
        return '#6B7280';
    }
  }

  const parseValue = (valueString) => {
    const [count] = valueString.split(' de ');
    return parseInt(count);
  }

  const data = report?.lines?.map(line => ({
    name: getSegmentLabel(line.key),
    value: parseValue(line.value),
    color: getColorForSegment(line.key),
    icon: getIconForSegment(line.key)
  })) || [];

  const totalCount = data.reduce((sum, item) => sum + item.value, 0);

  const CustomLabel = ({ cx, cy }) => {
    return (
      <text 
        x={cx} 
        y={cy} 
        textAnchor="middle" 
        dominantBaseline="middle" 
        className="text-2xl font-bold fill-gray-900"
      >
        {totalCount.toLocaleString()}
      </text>
    );
  };

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaBasketballBallSolid className="text-xl text-red-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Aguardando por Segmento'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      <div className="flex flex-col items-center">
        <div className="h-72 w-72">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={110}
                paddingAngle={2}
                dataKey="value"
                label={CustomLabel}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Chart Labels at Bottom */}
        <div className="flex justify-center gap-4 mt-4">
          {data.map((item, index) => {
            return (
              <div key={index} className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full flex-shrink-0" 
                  style={{ backgroundColor: item.color }}
                ></div>
                <div className="text-center">
                  <p className="text-xs font-medium text-gray-600">{item.name}</p>
                  <p className="text-base font-bold text-gray-900">{item.value.toLocaleString()}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Aguardando por Segmento'}
        description={report?.description}
      />
    </>
  );
};

export default WaitingBySegmentChart;
